import {
  FacturationGroupCreateDto,
  FacturationGroupUpdateDto,
  FacturationMode,
  FacturationModeUpdateDto,
  FacturationRule,
  FacturationRuleUpdateDto
} from '@store/clients/details/facturationMode/facturation-mode.model';

const formatFacturationRule = (data: FacturationRule): FacturationRuleUpdateDto =>
  ({...data, value: data.value.map((it) => it.id)});

export const formatFacturationModeToUpdateDto = (
  old: FacturationMode,
  current: FacturationMode
): FacturationModeUpdateDto => {
  return {
    id: current.id,
    name: current.name,
    sendInvoiceByMail: current.sendInvoiceByMail,
    email: current.email,
    createGroups: current.facturationGroups
      .flatMap((facturationGroup): FacturationGroupCreateDto | FacturationGroupCreateDto[] => (
        !facturationGroup.id ? ({
          ...facturationGroup,
          createRules: facturationGroup.facturationRules.map(formatFacturationRule)
        }) : []
      )),
    updateGroups: current.facturationGroups
      .flatMap((facturationGroup): FacturationGroupUpdateDto | FacturationGroupUpdateDto[] => (
        facturationGroup.id ? ({
          ...facturationGroup,
          createRules: facturationGroup.facturationRules.filter((facturationRule) => !facturationRule.id).map(formatFacturationRule),
          updateRules: facturationGroup.facturationRules.filter((facturationRule) => !!facturationRule.id).map(formatFacturationRule),
          deleteRulesIds: old.facturationGroups.find((oldFacturationGroup) =>
            oldFacturationGroup.id === facturationGroup.id)?.facturationRules.filter((oldFacturationRule) =>
            !facturationGroup.facturationRules.some((it) => it.id === oldFacturationRule.id))
            ?.flatMap((it) => it.id ? it.id : []) ?? [],
        }) : []
      )),
    deleteGroupsIds: old.facturationGroups.filter((oldFacturationGroup) =>
      !current.facturationGroups.some((it) => it.id === oldFacturationGroup.id))
      ?.flatMap((it) => it.id ? it.id : []) ?? []
  };
};
